import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseService } from '../../base/util/base.service';
import {
    adminBuscarChatbotConfigs,
    adminBuscarConfigs,
    adminBuscarConfigsLogin,
    adminBuscarEmailConfigs,
    adminBuscarSiebelConfigs,
    adminBuscarTokenGTOConfigs,
    adminSalvarChatbotConfigs,
    adminSalvarConfigs,
    adminSalvarEmailConfigs,
    adminSalvarSiebelConfigs,
    adminSalvarTokenGTOConfigs,
} from '../../base/util/url-util';
import { MessageService } from 'primeng/components/common/messageservice';
import { Configs } from '../../base/vo/configs';
import { ConfigsSiebel } from '../../base/vo/configs-siebel';
import { ConfigsEmail } from '../../base/vo/configs-email';
import { ConfigsChatbot } from '../../base/vo/configs-chatbot';
import { ConfigsTokenGTO } from '../../base/vo/configs-token-gto';

@Injectable()
export class AdminConfigsService extends BaseService {

    constructor(public http: HttpClient, public messageService: MessageService) {
        super(http, messageService);
    }

    buscarConfigs() {
        return this.get(adminBuscarConfigs());
    }

    salvarConfigs(configs: Configs) {
        return this.post(adminSalvarConfigs(), configs);
    }

    buscarSiebelConfigs() {
        return this.get(adminBuscarSiebelConfigs());
    }

    salvarSiebelConfigs(configs: ConfigsSiebel) {
        return this.post(adminSalvarSiebelConfigs(), configs);
    }

    buscarEmailConfigs() {
        return this.get(adminBuscarEmailConfigs());
    }

    salvarEmailConfigs(configs: ConfigsEmail) {
        return this.post(adminSalvarEmailConfigs(), configs);
    }

    buscarChatbotConfigs() {
        return this.get(adminBuscarChatbotConfigs());
    }

    salvarChatbotConfigs(configs: ConfigsChatbot) {
        return this.post(adminSalvarChatbotConfigs(), configs);
    }

    buscarTokenGTOConfigs() {
        return this.get(adminBuscarTokenGTOConfigs());
    }

    salvarTokenGTOConfigs(configs: ConfigsTokenGTO) {
        return this.post(adminSalvarTokenGTOConfigs(), configs);
    }

    buscarConfigsLogin() {
        return this.get(adminBuscarConfigsLogin());
    }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/configs/admin-configs.service.ts